import type { Comment } from '~/gql/queries.ts'
import parse from 'html-react-parser'

export default function Comment({ comment }: { comment: Comment }) {
	return (
		<div className="mt-4" key={comment.id}>
			<div className="flex flex-row space-x-1 text-xs font-thin uppercase tracking-wider text-gray-600">
				<div>By {comment.author.node.name}</div>
				<div>
					on{' '}
					{new Date(`${comment.date} UTC`).toLocaleDateString('en-US', {
						day: '2-digit',
						month: '2-digit',
						year: 'numeric',
					})}{' '}
					at{' '}
					{new Date(`${comment.date} UTC`).toLocaleTimeString('en-US', {
						hour: '2-digit',
						minute: '2-digit',
					})}
				</div>
			</div>
			<div className="text-sm">
				{parse.domToReact(parse.htmlToDOM(comment.content))}
			</div>
		</div>
	)
}
